import { render, staticRenderFns } from "./Garantias.vue?vue&type=template&id=df92c388&"
import script from "./Garantias.vue?vue&type=script&lang=js&"
export * from "./Garantias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports